var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sdr-box contact-box" }, [
    _c("h4", [_vm._v(_vm._s(_vm.needhelp[_vm.getCurrentLocale]))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.sideboxhelptext[_vm.getCurrentLocale]))]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("br"),
    _c("h4", [_vm._v(_vm._s(_vm.forbeirut[_vm.getCurrentLocale]))]),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("address", { staticClass: "contact-details" }, [
      _c("span", { staticClass: "contact-phone" }, [
        _c("i", { staticClass: "soap-icon-phone" }),
        _vm._v(" +49 30 53676791"),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "contact-email",
          attrs: { href: "mailto:kundenservice@sundair.com" },
        },
        [_vm._v("kundenservice@sundair.com")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("address", { staticClass: "contact-details" }, [
      _c("span", { staticClass: "contact-phone" }, [
        _c("i", { staticClass: "soap-icon-phone" }),
        _vm._v(" +49 30 81455700"),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "contact-email",
          attrs: { href: "mailto:bey@sundair.com" },
        },
        [_vm._v("bey@sundair.com")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }